import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from "@mui/material/TextField";
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { ThemeProvider } from '@mui/styles';
import React, { Component } from 'react';
import NumberFormat from 'react-number-format';
import { Link } from 'react-router-dom';
import { BlueButton } from "../../components/BlueButton";
import CircularLoading from '../../components/CircularLoading';
import { Product } from '../../components/Product';
import { GetAddresses, GetAddressLine2, GetdeliveryServices } from '../../services/Address';
import { CheckNIP, GetProduct, GetProductCatalog } from "../../services/Product";
import { GetToken, GuestLogin, Me, RefreshSession, SetToken, SetUser } from '../../services/Session';
import { CreateOrder, GetVoucherByCode } from '../../services/Transaction';
import '../../styles/style.css';
import theme from '../../styles/theme';

import dayjs from 'dayjs';

const BackIcon = '/assets/svg/back.svg';

class NewOrderMember extends Component {
	constructor(props) {
		super(props);
		this.state = {
			product_type: this.props.location.state.product_type,
			open_product_list: false,
			selectedAddress: {},
			product_catalog: [],
			open_alert_submit: false,
			loading: false,
			loading_address: false,
			open_modal_delivery: false,
			loading_check_voucher: false,
			input_voucher: false,
			voucher_not_found: false,
			voucher_not_valid: false,
			is_hide_courier: true,
			delivery_service: [],
			selected_delivery: {},
			item_list: [
				{
					colors: [],
					image_url: this.props.location.state.image_url,
					keys: [],
					product_code: this.props.location.state.product_code,
					product_name: this.props.location.state.product_name,
					products: [],
					qty: 1,
					selected_color: '',
					selected_product: '',
					selected_size: '',
					size: [],
					subtotal: this.props.location.state.unit_price * 1,
					unit_price: this.props.location.state.unit_price,
					weight: 300,
					note: '',
					nip: '',
					student_id_number: '',
					student_name: '',
				},
			],
			voucher: {
				code: '',
				max_delivery_cost_discount: 0,
				quota_per_user: 0,
				remain: 0,
			},
			...this.props.location.state,
		};
		if (!this.state.subtotal) {
			this.state.subtotal = this.state.unit_price;
		}
		if (!this.state.delivery_cost) {
			this.state.delivery_cost = 0;
		}
	}

	async componentDidMount() {
		const { item_list } = this.state;

		await this.handleGetOptions(item_list[0].product_code, 0);
		this.handleGetCatalog();
		this.handleGetAddresses();
	}

	handleGetCatalog = async () => {
		const { product_type } = this.state;
		let catalog_filter = (product_type == 'pre_order' || product_type == 'pre_order_member') ? { 
			'is_active': true,
			'type.$in': product_type == 'pre_order_member' ? product_type : 'certificate,pre_order',
			'open_at.$lte': dayjs().format(),
			'closed_at.$gte': dayjs().format(),
			'sorts': 'sort_number',
		} : {
			'is_active': true,
			'type': product_type,
			'sorts': 'sort_number',
		}

		this.setState({ loading: true });

		try {
			const { data } = await GetProductCatalog(catalog_filter);

			this.setState({ loading: false, product_catalog: data.results });
		} catch {
			this.setState({ loading: false });
		}
	};

	handlePostOrder = async () => {
		const { item_list, selectedAddress, voucher, selected_delivery } = this.state;
		const { history } = this.props;

		if (this.ableToSubmitOrder()) {
			this.setState({ loading: true });

			try {
				const payload = {
					line_items: item_list.map((item) => {

						// rebuild key from item_list `key-keyId`
						const key = item.keys.reduce((r, key) => `${r}${key}-${item[`selected_${key}`]}`, '');
						return {
							product: {
								id: item.products[key],
							},
							certificate: {
								nip: item.nip,
								name: item.student_name,
							},
							quantity: item.qty,
							note: item.note,
						};
					}),
					delivery_service: {
						courier_service: {
							code: selected_delivery?.courier_service?.code,
						},
						destination_address: {
							id: selectedAddress.id
						},
						weight: this.totalWeight(),
					},
					voucher_code: voucher.code,
				};
				const { data } = await CreateOrder(payload);

				this.setState({ loading: false });
				history.push({
					pathname: `/transaksi/${data.number}`,
					state: { order_detail: data },
				});
			} catch (err) {
				this.setState({ loading: false });
				if (err.response) {
					if (err.response.status === 401) {
						if (GetToken().refresh_token) {
							RefreshSession();
							setTimeout(this.handlePostOrder(), 3000);
						} else {
							alert('gagal terhubung ke server');
							this.handleLogout();
						}
					} else if (err.response.data.error?.message) {
						alert(err.response.data.error.message);
					} else {
						alert('gagal terhubung ke server');
					}
				} else {
					alert('gagal terhubung ke server');
				}
			}
		} else {
			this.handleToggleSubmitOrder();
		}
	};

	handleLogout = async () => {
		const { history } = this.props;

		try {
			const { data: login } = await GuestLogin();
			const { data: user } = Me(SetToken(login.token).access_token);

			SetUser(user.data);
			setTimeout(() => {
				history.push('/');
			}, 3e3);
		} catch {}
	};

	handleGetOptions = async (product_code, index) => {
		const { item_list, product_type } = this.state;
		let product_filter = (product_type == 'ready_stock') ? {
			'catalog.code': product_code,
			'quantity.available.$gt': 0,
			'is_active': true,
			'sorts': 'size.id',
		} : {
			'catalog.code': product_code,
			'is_active': true,
			'sorts': 'size.id',
		}

		if (product_type == 'pre_order_member' || product_type == 'pre_order') {
			this.setState({ is_hide_courier: true });
		}
		this.setState({ loading: true });

		try {
			const { data } = await GetProduct(product_filter);

			this.setState({ loading: false });

			if (data.results.length > 0) {
				const itemList = [...item_list];
				const keys = [];
				const colors = data.results
					.reduce((list, p) => {
						if (!p.color || list.some((c) => c.id === p.color.id)) return list;

						const sameColorProducts = data.results.filter((op) => op.color.id === p.color.id);
						const validSizeList = sameColorProducts.map((op) => op.size?.id).filter(Boolean);

						return list.concat({ ...p.color, size: validSizeList });
					}, [])
					.sort((a, b) => a.id - b.id);
				const size = data.results.reduce((list, p) => {
					if (!p.size || list.some((c) => c.id === p.size.id)) return list;

					const sameSizeProducts = data.results.filter((op) => op.size.id === p.size.id);
					const validColors = sameSizeProducts.map((op) => op.color?.id).filter(Boolean);

					return list.concat({ ...p.size, colors: validColors });
				}, []);

				// store required keys to get correct product id later
				if (size.length) {
					keys.push('size');
				}

				if (colors.length) {
					keys.push('color');
				}

				itemList[index].colors = colors;
				itemList[index].keys = keys;
				itemList[index].size = size;
				itemList[index].selected_product = data.results[0].id;
				itemList[index].weight = data.results[0].weight;

				if (size.length === 1) {
					itemList[index].selected_size = size[0].id;
				}

				if (colors.length === 1) {
					itemList[index].selected_color = colors[0].id;
				}

				// normalize product based on keys combination `key-keyId`
				itemList[index].products = data.results.reduce((map, product) => {
					const key = keys.reduce((r, key) => `${r}${key}-${product[key].id}`, '');

					return { ...map, [key]: product.id };
				}, {});

				this.setState({ item_list: itemList });
			}
		} catch (err) {
			this.setState({ loading: false });
			if (err.response) {
				if (err.response.status === 401) {
					if (GetToken().refresh_token !== null) {
						RefreshSession();
						setTimeout(this.handleGetOptions(product_code, index), 3000);
					} else {
						alert('gagal terhubung ke server');
						this.handleLogout();
					}
				} else if (err.response.data.error && err.response.data.error && err.response.data.error.message) {
					alert(err.response.data.error.message);
				} else {
					alert('gagal terhubung ke server');
				}
			} else {
				alert('gagal terhubung ke server');
			}
		}
	};

	handleGetAddresses = () => {
		const { state } = this.props.location;

		if (state?.selectedAddress) {
			this.setState({
				selectedAddress: state.selectedAddress,
			});

			return;
		}

		this.setState({ loading_address: true });

		GetAddresses({ is_primary: true })
			.then((res) => {
				this.setState({
					loading_address: false,
				});
				if (res.data.results.length > 0) {
					this.setState({
						selectedAddress: res.data.results[0],
					});
				}
			})
			.catch((err) => {
				this.setState({ loading: false });
				if (err.response) {
					if (err.response.status === 401) {
						if (GetToken().refresh_token !== null) {
							RefreshSession();
							setTimeout(this.handleGetAddresses(), 3000);
						} else {
							alert('gagal terhubung ke server');
							this.handleLogout();
						}
					} else if (err.response.data.error && err.response.data.error && err.response.data.error.message) {
						alert(err.response.data.error.message);
					} else {
						alert('gagal terhubung ke server');
					}
				} else {
					alert('gagal terhubung ke server');
				}
			});
	};

	totalWeight = () => {
		const { item_list } = this.state;
		let total_weight = 0;
		item_list.forEach((item) => {
			total_weight += item.weight * item.qty;
		});
		return total_weight;
	};

	handleGetDeliveryService = async () => {
		const { selectedAddress } = this.state;
		this.setState({ loading_get_delivery: true });
		GetdeliveryServices({ 'destination_address.id': selectedAddress.id, weight: this.totalWeight() })
			.then((res) => {
				this.setState({
					loading_get_delivery: false,
				});
				if (res.data.results.length > 0) {
					this.setState({
						delivery_service: res.data.results,
					});
				}
			})
			.catch((err) => {
				this.setState({ loading_get_delivery: false });

				if (err.response) {
					if (err.response.status === 401) {
						if (GetToken().refresh_token !== null) {
							RefreshSession();
							setTimeout(this.handleGetDeliveryService(), 3000);
						} else {
							alert('gagal terhubung ke server');
							this.handleLogout();
						}
					} else if (err.response.data.error && err.response.data.error && err.response.data.error.message) {
						alert(err.response.data.error.message);
					} else {
						alert('gagal terhubung ke server');
					}
				} else {
					alert('gagal terhubung ke server');
				}
			});
	};

	handleDropdownChange = (value, index, property) => {
		const { item_list } = this.state;
		const itemList = [...item_list];

		itemList[index][property] = value;
		this.setState({
			item_list: itemList,
			selected_delivery: {},
			delivery_service: [],
		});
	};

	increment = (index) => {
		const { item_list } = this.state;
		let itemList = [...item_list];
		let current_qty = itemList[index].qty;
		itemList[index].qty = ++current_qty;
		itemList[index].subtotal = itemList[index].unit_price * current_qty;
		this.setState({
			item_list: itemList,
			selected_delivery: {},
			delivery_service: [],
		});
	};

	decrement = (index) => {
		const { item_list } = this.state;
		let itemList = [...item_list];
		let current_qty = itemList[index].qty;
		itemList[index].qty = current_qty > 0 ? --current_qty : 0;
		itemList[index].subtotal = itemList[index].unit_price * current_qty;
		this.setState({
			item_list: itemList,
			selected_delivery: {},
			delivery_service: [],
		});
	};

	handleChangeText = (name, index) => event => {
		const { item_list } = this.state
		let itemList = [...item_list];
		itemList[index][name] = (name === 'student_id_number') ? event.target.value.toUpperCase() : event.target.value
		this.setState({ item_list: itemList })
	}


	handleCheckNIP = (nip, index) => {
		const { item_list } = this.state
		let itemList = [...item_list];
		CheckNIP(nip)
			.then(res => {
				if (res.data !== undefined) {
					itemList[index].nip = res.data.nip
					itemList[index].student_id_number = res.data.nip
					itemList[index].student_name = res.data.name
					this.setState({ item_list: itemList })
				}
			})
			.catch(err => {
				alert('NIP ' + nip + ' tidak ditemukan')
			})
		this.setState({ item_list: itemList })
	}


	handleChangeNote = (index) => (event) => {
		const { item_list } = this.state;
		let itemList = [...item_list];
		itemList[index].note = event.target.value;
		this.setState({
			item_list: itemList,
			selected_delivery: {},
			delivery_service: [],
		});
	};

	handleChangeVoucherCode = (event) => {
		this.setState({
			voucher: {
				code: event.target.value,
				max_delivery_cost_discount: 0,
				quota_per_user: 0,
				remain: 0,
			},
		});
	};

	checkVoucherCode = async () => {
		const { voucher, product_type } = this.state;
		this.setState({ loading_check_voucher: true });
		GetVoucherByCode(voucher.code)
			.then((res) => {
				this.setState({ loading_check_voucher: false });
				if (res.data && res.data.type && res.data.type.includes(product_type)) {
					this.setState({ voucher: res.data });
				} else {
					this.setState({ voucher_not_valid: true });
				}
			})
			.catch((err) => {
				this.setState({ loading_check_voucher: false });
				if (err.response) {
					if (err.response.status === 401) {
						if (GetToken().refresh_token !== null) {
							RefreshSession();
							setTimeout(this.checkVoucherCode(), 3000);
						} else {
							alert('gagal terhubung ke server');
							this.handleLogout();
						}
					} else {
						this.setState({ voucher_not_found: true });
					}
				} else {
					alert('gagal terhubung ke server');
				}
			});
	};

	removeProduct = (index) => {
		const { item_list } = this.state;
		let itemList = item_list.filter((item, idx) => idx !== index);
		this.setState({
			item_list: itemList,
			selected_delivery: {},
			delivery_service: [],
		});
	};

	getColors = ({ colors, selected_size }) =>
		selected_size ? colors.filter((c) => c.size.includes(selected_size)) : colors;

	getSizeList = ({ size, selected_color }) =>
		selected_color ? size.filter((c) => c.colors.includes(selected_color)) : size;

	lineItem = () => {
		const { item_list } = this.state;

		return item_list.map((item, idx) => (
			<Card key={idx} className="order-card" style={{ textAlign: 'left', height: 'auto', width: '90%' }}>
				<CardMedia style={{ width: 150, height: 170 }} image={item.image_url} title="produk" />
				<div style={{ padding: 10, fontSize: 14, width: '100%' }}>
					<Grid container spacing={1}>
						<Grid item xs={6}>
							<b>{item.product_name}</b>
						</Grid>
						<Grid item xs={6} style={{ textAlign: 'right' }}>
							<Button
								size="small"
								color="secondary"
								onClick={() => this.removeProduct(idx)}
								style={{ textTransform: 'none' }}
								startIcon={<DeleteIcon />}
							>
								Hapus
							</Button>
						</Grid>
						<Grid item xs={6}>
							Harga satuan:
						</Grid>
						<Grid item xs={6} style={{ color: '#00bfe6', textAlign: 'right' }}>
							<NumberFormat
								value={item.unit_price}
								displayType={'text'}
								thousandSeparator={'.'}
								decimalSeparator={','}
								prefix={'Rp '}
							/>
						</Grid>
						<Grid container item>
							<Grid item xs={3}>
								NIP:
							</Grid>
							<Grid item xs={9}>
								<div className="center" style={{ display: 'flex', alignItems: 'center' }} >
									<TextField
										id="student_id_number"
										name="student_id_number"
										value={item.student_id_number || ''}
										size="small"
										style={{ width: '100%' }}
										onChange={this.handleChangeText('student_id_number', idx)}
										autoFocus
									/>
									<Button
										variant="contained"
										color="primary"
										style={{ height: 30, marginLeft: 10 }}
										onClick={() => this.handleCheckNIP(item.student_id_number, idx)}
									>Cek</Button>
								</div>
							</Grid>
						</Grid>
						<Grid container item>
							<Grid item xs={3}>
								Nama:
							</Grid>
							<Grid item xs={9}>
								<TextField
									id="student_name"
									name="student_name"
									value={item.student_name || ''}
									style={{ width: '100%' }}
									size="small"
									onChange={this.handleChangeText('student_name', idx)}
								/>
							</Grid>
						</Grid>
						{item.size.length > 0 && (
							<Grid container item>
								<Grid item xs={3}>
									Ukuran:
								</Grid>
								<Grid item xs={9}>
									<Select
										labelId="size-select-label"
										id="size-select"
										displayEmpty
										onChange={(e) => this.handleDropdownChange(e.target.value, idx, 'selected_size')}
										value={item.selected_size}
										style={{ width: '100%', fontSize: '14px', paddingLeft: '5px' }}
									>
										<MenuItem value="">Pilih</MenuItem>
										{this.getSizeList(item).map(({ code, id }) => (
											<MenuItem key={id} value={id}>
												{code}
											</MenuItem>
										))}
									</Select>
								</Grid>
							</Grid>
						)}
						{item.colors.length > 0 && (
							<Grid container item>
								<Grid item xs={3}>
									Warna:
								</Grid>
								<Grid item xs={9}>
									<Select
										labelId="color-select-label"
										id="color-select"
										displayEmpty
										onChange={(e) => this.handleDropdownChange(e.target.value, idx, 'selected_color')}
										value={item.selected_color}
										style={{ width: '100%', fontSize: '14px', paddingLeft: '5px' }}
									>
										<MenuItem value="">Pilih</MenuItem>
										{this.getColors(item).map(({ code, id, name }) => (
											<MenuItem key={id} value={id}>
												<span className="color-circle" style={{ backgroundColor: code }}></span>
												{name}
											</MenuItem>
										))}
									</Select>
								</Grid>
							</Grid>
						)}
						<Grid item xs={3}>
							Jumlah:
						</Grid>
						<Grid item xs={9} style={{ textAlign: 'right' }}>
							<ButtonGroup disableElevation size="small" aria-label="small outlined button group">
								<Button disabled={item.qty === 1} onClick={() => this.decrement(idx)}>
									-
								</Button>
								<Button disabled>{item.qty}</Button>
								<Button onClick={() => this.increment(idx)}>+</Button>
							</ButtonGroup>
						</Grid>
					</Grid>
				</div>
			</Card>
		));
	};

	deliveryAddress = () => {
		const { selectedAddress, loading_address } = this.state;
		return (
			<Card className="order-card" style={{ textAlign: 'left', padding: '0', width: '90%' }}>
				<div style={{ padding: 10, fontSize: 14, width: '100%', position: 'relative' }}>
					<div>
						<b>Alamat Pengiriman:</b>
					</div>
					{loading_address ? (
						<div style={{ display: 'table', margin: '0 auto' }}>
							<CircularLoading />
						</div>
					) : Object.keys(selectedAddress).length === 0 && selectedAddress.constructor === Object ? (
						<Button
							variant="outlined"
							onClick={this.selectAddress}
							color="primary"
							style={{ textTransform: 'none', height: 40, width: '100%', margin: '10px 0 5px' }}
						>
							Tentukan alamat pengiriman
						</Button>
					) : (
						<div>
							<IconButton
								onClick={this.selectAddress}
								style={{ position: 'absolute', top: '10px', right: '10px' }}
								size="small"
							>
								<EditIcon fontSize="small" />
							</IconButton>
							<div style={{ fontSize: 12 }}>
								<div>
									<b>{selectedAddress.contact_person}</b>
								</div>
								<div>{selectedAddress.complete}</div>
								<div>{GetAddressLine2(selectedAddress)}</div>
								<div>Nomor HP : {selectedAddress.phone}</div>
							</div>
						</div>
					)}
				</div>
			</Card>
		);
	};

	courier = () => {
		const { loading_get_delivery, selected_delivery, delivery_service, open_modal_delivery } = this.state
		return (
			<Card className="order-card" style={{ textAlign: "left", height: "auto", width: '90%' }}>
				<div style={{ padding: 10, fontSize: 14, width: "100%" }}>
					<Grid container spacing={1}>
						<Grid item xs={6}>
							<b>Jasa Pengiriman:</b>
						</Grid>
						{Object.entries(selected_delivery).length !== 0 && (
							<Grid item xs={6} style={{ textAlign: 'right' }}>
								<IconButton onClick={this.handleToggleModalDelivery} size="small">
									<EditIcon fontSize="small" />
								</IconButton>
							</Grid>
						)}
					</Grid>
					{Object.entries(selected_delivery).length !== 0 ? <MenuItem style={{ paddingLeft: 0, paddingRight: 0 }} onClick={() => this.handleToggleModalDelivery()}>
						<div style={{ width: "100%" }}>
							<div style={{ width: "65%", float: "left" }}>
								<div style={{ clear: "both", display: "block", overflow: "hidden", fontSize: "12px" }}>{selected_delivery.courier_service.name}</div>
								<div style={{ fontSize: '10px', clear: "both", display: "block" }}>Pengiriman {selected_delivery.etd.min} - {selected_delivery.etd.max} Hari</div>
							</div>
							<div style={{ width: "35%", float: "left", textAlign: "right", fontSize: "12px" }}>
								<NumberFormat value={selected_delivery.cost} displayType={"text"} thousandSeparator={"."} decimalSeparator={","} prefix={"Rp "} />
							</div>
						</div>
					</MenuItem> : <Button variant="outlined" onClick={() => this.handleToggleModalDelivery()} color="primary" style={{ textTransform: "none", height: 40, width: '100%', margin: "10px 0 0" }}>
						Pilih Jasa Pengiriman
					</Button>}

					<Dialog onClose={this.handleToggleModalDelivery} open={open_modal_delivery}>
						<div style={{ fontSize: '14px', padding: '25px 50px 10px 16px', fontFamily: 'Open Sans' }}>Pilih Jasa Pengiriman</div>
						<IconButton aria-label="close" style={{ position: 'absolute', right: 10, top: 10 }} onClick={this.handleToggleModalDelivery}>
							<CloseIcon />
						</IconButton>
						{loading_get_delivery ? <div style={{ display: 'table', margin: '0 auto 20px' }}><CircularLoading /></div> : delivery_service.map((service, idx) => <MenuItem key={idx} onClick={() => this.handleDeliveryChange(service)} style={{ zIndex: 9999 }}>
							<div style={{ width: "200px", zIndex: 999 }}>
								<div style={{ width: "65%", float: "left" }}>
									<div style={{ clear: "both", display: "block", overflow: "hidden", fontSize: "12px" }}>{service.courier_service.name}</div>
									<div style={{ fontSize: '10px', clear: "both", display: "block" }}>Pengiriman {service.etd.min} - {service.etd.max} Hari</div>
								</div>
								<div style={{ width: "35%", float: "left", textAlign: "right", fontSize: "12px" }}>
									<NumberFormat value={service.cost} displayType={"text"} thousandSeparator={"."} decimalSeparator={","} prefix={"Rp "} />
								</div>
							</div>
						</MenuItem>)}
					</Dialog>
				</div>
			</Card>
		)
	}

	voucherCode = () => {
		const { voucher, input_voucher, loading_check_voucher, voucher_not_found, voucher_not_valid } = this.state;
		let buttonLabel = 'Cek';
		let buttonOnClick = this.checkVoucherCode;
		let msg = '';
		if (loading_check_voucher) {
			buttonLabel = <CircularLoading size={20} />;
		} else if (voucher.remain && voucher.max_delivery_cost_discount) {
			buttonLabel = 'Gunakan';
			buttonOnClick = () => this.setState({ input_voucher: !input_voucher });
			msg = <div>Selamat, kamu mendapatkan potongan ongkos kirim maksimal sebesar <span>
				<NumberFormat
					value={voucher.max_delivery_cost_discount}
					displayType={'text'}
					thousandSeparator={'.'}
					decimalSeparator={','}
					prefix={'Rp '}
				/>
			</span>
			</div>
		} else if (voucher_not_found) {
			msg = <span style={{ color: 'orange' }}>Maaf, kode voucher yang kamu masukan tidak ditemukan.</span>;
		} else if (voucher_not_valid) {
			msg = <span style={{ color: 'orange' }}>Maaf, kode voucher yang kamu masukan tidak berlaku untuk produk ini.</span>;
		} else if (voucher.quota_per_user) {
			msg = <span style={{ color: 'orange' }}>Maaf, kode voucher yang kamu masukan sudah digunakan pada transaksi lain. Kode voucher tersebut hanya bisa digunakan sebanyak {voucher.quota_per_user} kali</span>;
		}

		return (
			<Card className="order-card" style={{ textAlign: 'left', width: '90%' }}>
				{(voucher && voucher.code) ? (
					<div style={{ padding: 10, fontSize: 14, width: '100%' }}>
						<Grid container>
							<Grid item xs={6}>
								<b>Voucher:</b>
							</Grid>
							<Grid item xs={6} style={{ textAlign: 'right' }}>
								<IconButton onClick={() => this.setState({ input_voucher: !input_voucher })} size="small">
									<EditIcon fontSize="small" />
								</IconButton>
							</Grid>
							<Grid item xs={12}>
								{voucher.code}
							</Grid>
							<Grid item xs={12} style={{ fontSize: 12 }}>
								{msg}
							</Grid>
						</Grid>
					</div>
				) : (
					<Button
						variant="outlined"
						onClick={() => this.setState({ input_voucher: !input_voucher })}
						color="primary"
						style={{ textTransform: 'none', height: 40, width: '100%', margin: '10px' }}
					>
						Gunakan Voucher
					</Button>
				)}
				<Dialog fullWidth open={input_voucher} onClose={() => this.setState({ input_voucher: !input_voucher })}>
					<DialogTitle id="customized-dialog-title">
						Voucher
						<IconButton
							aria-label="close"
							style={{ position: 'absolute', right: 10, top: 10 }}
							onClick={() => this.setState({ input_voucher: !input_voucher })}
						>
							<CloseIcon />
						</IconButton>
					</DialogTitle>
					<div style={{ padding: 10, paddingBottom: 20, fontSize: 14 }}>
						<Grid container spacing={1}>
							<Grid item xs={12}>
								<TextField
									id="voucher_code"
									name="voucher_code"
									label="Masukan Kode"
									style={{ width: '100%' }}
									variant="outlined"
									size="small"
									value={voucher.code}
									onChange={this.handleChangeVoucherCode}
								/>
							</Grid>
							<Grid item xs={12}>
								{msg}
							</Grid>
							<Grid item xs={12} style={{ textAlign: 'right' }}>
								<Button
									disabled={loading_check_voucher}
									onClick={buttonOnClick}
									variant="contained"
									color="primary"
									style={{ textTransform: 'none' }}
								>
									{buttonLabel}
								</Button>
							</Grid>
						</Grid>
					</div>
				</Dialog>
			</Card>
		);
	}

	handleDeliveryChange = (delivery_item) => {
		const { delivery_service } = this.state;
		let delivery_cost = '';
		delivery_service.forEach((delivery) => {
			if (delivery_item.id === delivery.id) {
				delivery_cost = delivery.cost;
			}
		});
		this.setState({
			selected_delivery: delivery_item,
			delivery_cost: delivery_cost || 0,
		});
		this.handleToggleModalDelivery();
	};

	selectAddress = () => {
		const { history, location } = this.props;
		const { item_list } = this.state;

		history.push('/alamat', { ...location.state, item_list });
	};

	ableToSubmitOrder = () => {
		const { selectedAddress, item_list, product_code } = this.state;

		if (!Object.keys(selectedAddress).length) {
			return false;
		}

		for (const item of item_list) {
			if (item.nip === '') return false;
			if (item.student_name === '') return false;
			if (item.colors.length > 0 && !item.selected_color) return false;
			if (item.qty === 0) return false;
			if (item.size.length > 0 && !item.selected_size) return false;
			if (product_code.includes('-aktn-') && item.note === '') return false;
		}

		return true;
	};

	handleProductClick = async (item) => {
		await this.setState((state) => {
			const newitem = {
				colors: [],
				image_url: item.image.url,
				product_code: item.code,
				product_name: item.name,
				products: [],
				qty: 1,
				selected_color: '',
				selected_size: '',
				size: [],
				subtotal: item.unit_price.max * 1,
				unit_price: item.unit_price.max,
				weight: item.weight,
				note: '',
				student_id_number: '',
				student_name: '',
			};

			return {
				item_list: [...state.item_list, newitem],
				selected_delivery: {},
				delivery_service: [],
			};
		});
		await this.handleGetOptions(item.code, this.state.item_list.length - 1);
		this.handleToggle();
	};

	handleToggle = () => {
		this.setState(({ open_product_list }) => ({ open_product_list: !open_product_list }));
	};

	handleToggleSubmitOrder = () => {
		this.setState(({ open_alert_submit }) => ({ open_alert_submit: !open_alert_submit }));
	};

	handleToggleModalDelivery = () => {
		const { open_modal_delivery } = this.state;

		if (!open_modal_delivery) this.handleGetDeliveryService();

		this.setState(({ open_modal_delivery }) => ({ open_modal_delivery: !open_modal_delivery }));
	};

	modalNotifSubmit = () => {
		const { open_alert_submit, selectedAddress, item_list } = this.state;
		const text = [];
		let invalidColor = false;
		let invalidQuantity = false;
		let invalidSize = false;
		let invalidNIP = false;
		let invalidName = false;

		item_list.forEach((item) => {
			invalidNIP = item.nip === '';
			invalidName = item.student_name === '';
			invalidColor = item.colors.length > 0 && !item.selected_color;
			invalidQuantity = item.qty === 0;
			invalidSize = item.size.length > 0 && !item.selected_size;
		});

		if (Object.keys(selectedAddress).length === 0) text.push('Alamat tujuan');
		if (invalidNIP) text.push('NIP tidak Valid, tekan tombol "Cek" untuk validasi NIP)');
		if (invalidName) text.push('Nama');
		if (invalidQuantity) text.push('Jumlah produk');
		if (invalidSize) text.push('Ukuran');
		if (invalidColor) text.push('Warna');

		return (
			<Dialog onClose={this.handleToggleSubmitOrder} aria-labelledby="customized-dialog-title" open={open_alert_submit}>
				<DialogTitle id="customized-dialog-title">
					Info
					<IconButton
						aria-label="close"
						style={{ position: 'absolute', right: 10, top: 10 }}
						onClick={this.handleToggleSubmitOrder}
					>
						<CloseIcon />
					</IconButton>
				</DialogTitle>
				<div style={{ padding: '0 24px 20px', fontFamily: 'Open Sans' }}>
					Mohon lengkapi info pemesanan berikut ini:
					{text && (
						<ul>
							{text.map((t, idx) => (
								<li key={idx}>{t}</li>
							))}
						</ul>
					)}
				</div>
			</Dialog>
		);
	};

	subtotal = () => this.state.item_list.reduce((acc, item) => acc + item.subtotal, 0);

	render() {
		const { product_catalog, open_product_list, voucher, loading, is_hide_courier } = this.state;

		let deliveryCostLabel = 'Biaya packing & pengiriman: Rp ';
		let deliveryCostAmount = this.state.delivery_cost;
		if (voucher.remain && voucher.max_delivery_cost_discount) {
			deliveryCostLabel = 'Biaya packing & pengiriman (setelah diskon): Rp ';
			deliveryCostAmount = (deliveryCostAmount > voucher.max_delivery_cost_discount) ? deliveryCostAmount - voucher.max_delivery_cost_discount : 0
		}

		return (
			<ThemeProvider theme={theme}>
				<div className="header">
					<Link
						to={'/produk/' + this.state.product_code}
						style={{ position: 'absolute', height: 60, width: 60, top: 0, left: 0 }}
					>
						<img alt="icon" src={BackIcon} />
					</Link>
					<div className="center">
						<h3 className="title">Lanjutkan Pesanan</h3>
					</div>
				</div>
				<div className="wrapper-white" style={{ paddingBottom: 200, backgroundColor: '#eeeeee' }}>
					<Grid container direction="column" justify="center" alignItems="center">
						{this.lineItem()}
						<Card className="order-card" style={{ textAlign: 'left', width: '90%' }}>
							<Button
								variant="outlined"
								onClick={this.handleToggle}
								color="primary"
								style={{ textTransform: 'none', height: 40, width: '100%', margin: '10px' }}
							>
								Tambah produk
							</Button>
							<Dialog fullWidth open={open_product_list} onClose={this.handleToggle}>
								<DialogTitle id="customized-dialog-title">
									Pilih produk lainnya
									<IconButton
										aria-label="close"
										style={{ position: 'absolute', right: 10, top: 10 }}
										onClick={this.handleToggle}
									>
										<CloseIcon />
									</IconButton>
								</DialogTitle>
								<div className="products">
									{product_catalog.map((data) => (
										<Product key={data.id} data={data} onClick={this.handleProductClick} />
									))}
								</div>
							</Dialog>
						</Card>
						{this.deliveryAddress()}
						{!is_hide_courier && this.courier()}
						{this.voucherCode()}
					</Grid>
				</div>
				<div className="footer" style={{ textAlign: 'center', height: 120 }}>
					<div style={{ width: 320, margin: 'auto', paddingTop: 5, textAlign: 'right', fontSize: 14 }}>
						<div>
							<NumberFormat
								value={this.subtotal()}
								displayType={'text'}
								thousandSeparator={'.'}
								decimalSeparator={','}
								prefix={'Subtotal: Rp '}
							/>
						</div>
						<div>
							<NumberFormat
								value={deliveryCostAmount}
								displayType={'text'}
								thousandSeparator={'.'}
								decimalSeparator={','}
								prefix={deliveryCostLabel}
							/>
						</div>
						<div>
							<NumberFormat
								value={this.subtotal() + deliveryCostAmount}
								displayType={'text'}
								thousandSeparator={'.'}
								decimalSeparator={','}
								prefix={'Jumlah yang harus dibayar: Rp '}
							/>
						</div>
					</div>
					<div style={{ textAlign: 'center' }}>
						<BlueButton 
							disabled={loading} 
							loading={loading} 
							onClick={this.handlePostOrder} 
							width={320} 
							text="Lanjutkan" />
					</div>
				</div>
				{this.modalNotifSubmit()}
			</ThemeProvider>
		);
	}
}

export default NewOrderMember;
